import React from 'react';
import './IndexSecondView.css';
import PropTypes from 'prop-types';
import { ButtonText } from '../ButtonSquare';
import PostPreview from '../PostPreview';
import TitleHeader from '../TitleHeader';

const IndexSecondView = (props) => {
  const {
    data: {
      edges: articles,
    },
  } = props;
  const postPreviewDivs = [];
  if (articles) {
    articles.forEach((element) => {
      const article = element.node;
      postPreviewDivs.push(<PostPreview
        key={article.slug}
        pictureSrc={article.pictures[0].sizes}
        alt={article.pictures[0].alt}
        title={article.title}
        subtitle={article.subtitle}
        link={`/${article.slug}`}
      />);
    });
  }

  return (
    <div className="view-body" id="références">
      <TitleHeader
        title="Ils nous ont fait confiance"
        titleColor="#4d12c7"
        subtitle="Derniers projets"
        subtitleColor="white"
      />
      <div className="post-container">
        {postPreviewDivs}
      </div>
      <div className="footer">
        <ButtonText link="/references-applications-sur-mesure">
          Voir les applications
        </ButtonText>
        <ButtonText link="/references-ecommerce">
          Voir les ecommerces
        </ButtonText>
        <ButtonText link="/references-sites-vitrine">
          Voir les sites vitrine
        </ButtonText>
      </div>
    </div>
  );
};

IndexSecondView.defaultProps = {
  data: {},
};

IndexSecondView.propTypes = {
  data: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({
      pictures: PropTypes.array,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      slug: PropTypes.string,
    })),
  }),
};

export default IndexSecondView;



// WEBPACK FOOTER //
// ./src/components/IndexSecondView/IndexSecondView.jsx